export default __webpack_public_path__ + "static/media/tankIcon.b7729e1d.svg";